<template>
  <v-container fluid class="ai-page">
    <v-row dense>
      <v-col cols="12" sm="8" md="5" lg="4">
        <v-select
          outlined
          dense
          hide-details
          background-color="white"
          prepend-inner-icon="mdi-domain"
          v-model="empresaSelecionada"
          :items="empresas"
          item-text="nome"
          item-value="id"
          label="Empresa"
          @input="carregaUsuarios()"
        ></v-select>
      </v-col>
    </v-row>

    <v-card class="ai-panel mt-3" elevation="0">
      <div class="ai-panel__head">
        <div class="ai-panel__title">
          <v-icon>mdi-account-group</v-icon>
          Usuários
          <span class="ai-count">{{ tabela.conteudo.length }}</span>
        </div>
        <div class="ai-panel__spacer"></div>
        <v-text-field
          v-model="tabela.busca"
          append-icon="mdi-magnify"
          label="Procurar"
          single-line
          hide-details
          dense
          outlined
          class="ai-search"
        ></v-text-field>
        <v-btn color="primary" depressed @click="dialogoUsuario = true" :disabled="empresaSelecionada == ''">
          <v-icon left>mdi-plus</v-icon>Cadastrar
        </v-btn>
      </div>

      <v-data-table
        :search="tabela.busca"
        :headers="tabela.cabecalho"
        :items="tabela.conteudo"
        sort-by="nome"
        class="ai-datatable"
        :footer-props="{ 'items-per-page-text': 'Linhas por página', 'items-per-page-all-text': 'Tudo' }"
        :loading="tabela.carregamento"
        loading-text="Buscando itens..."
      >
        <template v-slot:[`item.tipo`]="{ item }">
          <v-chip x-small label :color="corTipo(item.tipo)" text-color="white">{{ rotuloTipo(item.tipo) }}</v-chip>
        </template>
        <template v-slot:[`item.ativo`]="{ item }">
          <span class="ai-status" :class="item.ativo ? 'success--text' : 'error--text'">
            <v-icon x-small :color="item.ativo ? 'success' : 'error'">mdi-circle</v-icon>
            {{ item.ativo ? 'Ativo' : 'Inativo' }}
          </span>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on" @click="editItem(item)"><v-icon color="info">mdi-pencil</v-icon></v-btn>
            </template>
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on" @click="deleteItem(item)"><v-icon color="error">mdi-delete</v-icon></v-btn>
            </template>
            <span>Excluir</span>
          </v-tooltip>
        </template>
        <template v-slot:no-data>
          <div class="py-6">
            <v-alert v-if="empresaSelecionada == ''" dense text outlined color="info" class="ma-0 d-inline-flex">
              <v-icon left color="info">mdi-information</v-icon>Selecione uma empresa para visualizar os usuários
            </v-alert>
            <v-alert v-else dense text outlined color="warning" class="ma-0 d-inline-flex">
              <v-icon left color="warning">mdi-account-off</v-icon>Nenhum usuário cadastrado
            </v-alert>
          </div>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="dialogoUsuario" persistent max-width="520px" scrollable class="ai-dialog">
      <v-card>
        <v-card-title><v-icon>mdi-account</v-icon>{{ formTitle }}</v-card-title>
        <v-card-text class="ai-dialog-body">
          <p class="text-caption text--secondary mb-4">* indica preenchimento obrigatório</p>
          <v-row>
            <v-col cols="12">
              <v-text-field label="Nome*" outlined dense hide-details v-model="editedItem.nome"></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field label="E-mail*" outlined dense hide-details v-model="editedItem.email"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field label="Senha*" outlined dense hide-details v-model="editedItem.password"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field label="PIN*" outlined dense hide-details v-model="editedItem.pin"></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-select label="Tipo de Usuário*" outlined dense hide-details v-model="editedItem.tipo" :items="tiposUsuario" item-text="text" item-value="value"></v-select>
            </v-col>
            <v-col cols="12">
              <v-autocomplete multiple chips small-chips deletable-chips label="Painéis*" outlined dense hide-details v-model="editedItem.paineis" :items="paineis" item-text="description" item-value="id"></v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="error" @click="dialogoUsuario = false">Fechar</v-btn>
          <v-btn depressed color="primary" @click="salvarUsuario" v-if="editedIndex == -1">Salvar</v-btn>
          <v-btn depressed color="primary" @click="editarUsuario" v-if="editedIndex != -1">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <Snackbar ref=chamaSnackbar />
    <loading :active.sync="isLoading" :can-cancel="true" color="#038b8b" :is-full-page="fullPage"></loading>
  </v-container>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { baseApiUrl } from '@/global'
  import Snackbar from '../componentes/snackbar.vue'
  import axios from 'axios'
  import { mapState } from 'vuex'
  export default {
    components: { Snackbar, Loading, },
    data: () => ({
      isLoading: false,
      fullPage: true,
      empresas: [],
      paineis: [],
      empresaSelecionada: '',
      tabela: {
        busca: '',
        cabecalho: [
          { text: 'Nome', align: 'start', value: 'nome', },
          { text: 'E-mail', value: 'email' },
          { text: 'Tipo', value: 'tipo' },
          { text: 'PIN', value: 'pin' },
          { text: 'Ativo', value: 'ativo' },
          { text: 'Ações', value: 'action', sortable: false },
        ],
        carregamento: false,
        conteudo: [],
      },
      tiposUsuario: [
        // { text: 'Administrador', value: 'ADMIN' },
        { text: 'Enfermagem', value: 'ENFERMAGEM' },
        { text: 'Gerente', value: 'GERENTE' },
      ],
      dialogoUsuario: false,
      editedIndex: -1,
      editedItem: {
        nome: '',
        email: '',
        password: '',
        tipo: '',
        imagem: '',
        empresaId: '',
        pin: '',
        ativo: true,
      },
      defaultItem: {
        nome: '',
        email: '',
        password: '',
        tipo: '',
        imagem: '',
        empresaId: '',
        pin: '',
        ativo: true,
      },
    }),

    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj,
      formTitle () {
        return this.editedIndex === -1 ? 'Adicionar novo usuário' : 'Editar usuário'
      },
    }),

    watch: {
      dialogoUsuario(val) {
        if (val == false) {
          setTimeout(() => {
            this.editedIndex = -1
            this.editedItem = Object.assign({}, this.defaultItem)
          }, 300);
        }
      },

      empresas() {
        this.empresaSelecionada = this.empresas[0].id
        this.carregaUsuarios()
      },
    },

    mounted() {
      this.carregaEmpresas()
    },

    methods: {
      rotuloTipo(tipo) {
        const map = { ADMIN: 'Administrador', ENFERMAGEM: 'Enfermagem', GERENTE: 'Gerente' }
        return map[tipo] || tipo
      },

      corTipo(tipo) {
        const map = { ADMIN: 'secondary', GERENTE: 'accent', ENFERMAGEM: 'primary' }
        return map[tipo] || 'grey'
      },

      async carregaEmpresas() {
        await axios.get(baseApiUrl + 'Empresas?filter={"order":"nome ASC", "fields":{"nome": true, "id": true}}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data.length > 0) {
            this.empresas = response.data
          }
        })
      },

      async carregaUsuarios () {
        this.tabela.conteudo = []
        this.isLoading = true
        this.tabela.carregamento = true
        this.carregaPaineis()

        await axios.get(baseApiUrl + 'Usuarios?filter={"where":{"empresaId":"' + this.empresaSelecionada + '"}, "order": "nome ASC"}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data) {
            this.tabela.conteudo = response.data
            this.tabela.carregamento = false
          }
          this.isLoading = false
        })
      },

      async carregaPaineis() {
        await axios.get(baseApiUrl + 'Paineis?filter={"where":{"empresaId":"' + this.empresaSelecionada + '"}, "order": "description ASC"}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data) {
            this.paineis = response.data
          }
        })
      },

      editItem (item) {
        this.isLoading = true
        this.editedIndex = this.tabela.conteudo.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogoUsuario = true
        this.isLoading = false
      },

      async salvarUsuario() {
        var vm = this;
        if (!this.editedItem.nome || !this.editedItem.email || !this.editedItem.password || !this.editedItem.tipo || !this.editedItem.pin) {
          vm.$refs.chamaSnackbar.snack("orange", "Preencha todos os campos para prosseguir", "ATENÇÃO")
        } else {
          this.isLoading = true
          this.editedItem.empresaId = this.empresaSelecionada
          await axios.post(baseApiUrl + 'Usuarios/replaceOrCreate?access_token=' + sessionStorage.getItem('accToken'), this.editedItem)
          .then(response => {
            if (response.data) {
              this.isLoading = false
              this.dialogoUsuario = false
              vm.$refs.chamaSnackbar.snack("green", "Operação realizada com sucesso!", "INFORMAÇÃO")
              this.carregaUsuarios()
            }
          })
          .catch(error => {
            vm.$refs.chamaSnackbar.snack("red", "Erro ao realizar operação" + error.response.data.error.message, "DESCULPE")
          })
        }
      },

      async editarUsuario() {
        var vm = this;
        if (!this.editedItem.nome || !this.editedItem.email || !this.editedItem.password || !this.editedItem.tipo || !this.editedItem.pin) {
          vm.$refs.chamaSnackbar.snack("orange", "Preencha os campos para prosseguir", "ATENÇÃO")
        } else {
          this.isLoading = true
          await axios.put(baseApiUrl + 'Usuarios/' + this.editedItem.id + '?access_token=' + sessionStorage.getItem('accToken'), this.editedItem)
          .then(response => {
            if (response.data) {
              this.isLoading = false
              this.dialogoUsuario = false
              vm.$refs.chamaSnackbar.snack("green", "Operação realizada com sucesso!", "INFORMAÇÃO")
              this.carregaUsuarios()
            }
          })
          .catch(error => {
            vm.$refs.chamaSnackbar.snack("red", "Erro ao realizar operação" + error.response.data.error.message, "DESCULPE")
          })
        }
      },

      async deleteItem(item) {
        var r = confirm('Realmente deseja EXCLUIR o usuário ' + item.nome + '?')
        if (r == true) {
          await axios.delete(baseApiUrl + 'Usuarios/' + item.id + '?access_token=' + sessionStorage.getItem('accToken'))
          .then(() => {
            var vm = this;
            vm.$refs.chamaSnackbar.snack("green", "Operação realizada com sucesso!", "INFORMAÇÃO")
            this.carregaUsuarios()
          })
        }
      },

      async countPin(pin) {
        let count

        await axios.get(baseApiUrl + 'Usuarios/count?where={"pin": "' + pin + '"}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data) {
            count = response.data.count
          }
        })

        return count
      },
    },
  }
</script>

<style scoped>
</style>
